import { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from './config';

const StockSignalsTable = ({ refreshTrigger }) => {
  const [signals, setSignals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStockSignals = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/stock-signals`);
      setSignals(res.data.data);
    } catch (err) {
      console.error('Failed to fetch stock signals:', err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStockSignals();
  }, [refreshTrigger]);

  const openGrowwDetail = (search_id) => {
    const url = `https://groww.in/stocks/${search_id}`;
    window.open(url, '_blank');
  };

  return (
    <div className="card mt-4">
      <div className="card-header bg-primary text-white">📊 Stock Signals</div>
      <div className="card-body table-responsive">
        {loading ? (
          <div className="text-muted">Loading...</div>
        ) : signals.length === 0 ? (
          <div className="text-muted">No stock signals found.</div>
        ) : (
          <table className="table table-bordered table-hover table-sm">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Symbol</th>
                <th>Exchange</th>
                <th>LTP</th>
                <th>Volume</th>
                <th>Change%</th>
                <th>Volatility</th>
                <th>RSI</th>
                <th>Rank</th>
                <th>Should Buy</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {signals.map((s, idx) => (
                <tr key={s.id || idx}>
                  <td>{idx + 1}</td>
                  <td>{s.symbol}</td>
                  <td>{s.exchange}</td>
                  <td>{s.ltp}</td>
                  <td>{s.volume}</td>
                  <td>{s.change_percent}</td>
                  <td>{s.volatility}</td>
                  <td>{s.rsi}</td>
                  <td>{s.rank}</td>
                  <td>{s.should_buy ? '✅' : '❌'}</td>
                  <td>
                    <button
                      className="btn btn-success"
                      onClick={() => openGrowwDetail(s.search_id)}
                    > 
                        <i className="fas fa-arrow-right"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default StockSignalsTable;
